import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";

import "./election-floating-widget.m.css";

function ElectionFloatingWidget() {
  const [showWidgetButton, setShowWidgetButton] = useState(true);
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (location.pathname.split('/')[1] === "bihar-assembly-elections-2025") {
      setShowWidgetButton(false);
    }
  }, []);

  useEffect(() => {
    if (window && window.innerWidth < 1024) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  return (
    <>
      {showWidgetButton && (
        <div styleName="election-toggle-widget-wrapper" className="election-floating-widget">
          <div styleName="button-and-close-wrapper">
            <span
              styleName="close-widget-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowWidgetButton(false);
              }}
            >
              &times;
            </span>
            <Link
              styleName="flip-image-wrapper"
              href="https://www.deccanherald.com/bihar-assembly-elections-2025?utm_medium=floatingwidget&utm_campaign=bihar-elections-2025"
            >
              <div styleName="flip"></div>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default ElectionFloatingWidget;
